export enum ApiEndpoints {
  getAllOrgans = '/copia/api/v1/admin/organs',
  getOrgansList = '/copia/api/v1/admin/organs/llistat',
  deleteOrgan = '/copia/api/v1/admin/organs/esborrar',
  editOrgan = '/copia/api/v1/admin/organs/actualitzar',
  createOrgan = '/copia/api/v1/admin/organs/crear',
  getAllTemplates = `/copia/api/v1/admin/plantilles`,
  getTemplatesList = `/copia/api/v1/admin/plantilles/llistat`,
  createTemplate = `/copia/api/v1/admin/plantilles/crear`,
  deleteTemplate = `/copia/api/v1/admin/plantilles/esborrar`,
  editTemplate = `/copia/api/v1/admin/plantilles/actualitzar`,
  getCopies = `/copia/api/v1/documents`,
  getCopiesCSV = `/copia/api/v1/documents/csv`,
  createCopy = `/copia/api/v1/documents/generar`,
  deleteCopy = `/copia/api/v1/documents/esborrar`,
  downloadCopy = `/copia/api/v1/documents/descarregar`,
  getIdpInfo = '/copia/api/v1/idp/userInfo',
  logout = '/copia/validap-client/api/logout'
}
